<template>
  <div class="h-full">
    <base-flex-spinner v-if="loading" />
    <div
      v-else
      class="mx-6 pt-4"
    >
      <div v-if="orders.length" class="space-y-4">
        <OrderIndexRow v-for="order in orders" :key="order.id" :order="order" @click="setOrderId(order.id)" />
        <div class="text-center mb-4">
          <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="7"
            circle
          />
        </div>
        <action-modal
          v-if="orderId"
          :order-id="orderId"
          :opened="showModal"
          @close-modal="closeModal"
        />
      </div>
      <div
        v-else
        class="my-4 p-4 bg-white rounded-lg"
      >
        <span>Ce patient n’a passé aucune commande Click & collect.</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {orderApi} from '@/container';
import dayjs from 'dayjs';
import ActionModal from '@/order/components/OrderActionModal.vue';
import {OrderContentType, OrderIndex} from "@/order/interfaces/Order";
import cartBubble from '@/assets/icons/cart-bubble.svg';
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import OrderIndexRow from "@/order/components/OrderIndexRow.vue";

export default defineComponent({
    name: 'CustomerClickCollect',
    components: {
        OrderIndexRow,
        BaseFlexSpinner,
        ActionModal,
    },
    props: {
        customer: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            orders: [] as OrderIndex[],
            loading: false,
            showModal: false,
            orderId: null,
            page: 1,
            totalPage: 1,
            cartBubble
        };
    },
    computed: {
        dayjs() {
            return dayjs;
        },
    },
    watch: {
        page: {
            immediate: true,

            handler() {
                this.loading = true;
                this.loadClickCollect(this.customer.id)
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }
    },
    methods: {
        /**
         * Load the patient orders.
         *
         * @param consumerId
         * @return {Promise<unknown>}
         */
        loadClickCollect(consumerId) {
            return orderApi().patientIndex(consumerId, {page: this.page})
                .then((response) => {
                    this.orders = response.data;
                    this.totalPage = response.meta.last_page;
                });
        },
        /**
         * Subtitle of the order card.
         *
         * @param order
         * @return {string}
         */
        subtitle(order) {
            const orderDate = `Le ${dayjs(order.created_at).format('DD/MM/YYYY')}`;

            if (order.content_type !== OrderContentType.CART) {
                let subtitle = orderDate + ' - Ordonnance';
                if (order.prescriptor?.last_name) {
                    subtitle += ` du DR. ${order.prescriptor?.last_name}`;
                }
                if (order.content_type !== OrderContentType.RENEWAL) {
                    subtitle += ' envoyée pour renouvellement';
                }

                return subtitle;
            }

            const count = order.summary?.product_count;

            return count === 0 || count ? orderDate + ` - ${count} produits` : orderDate;
        },
        /**
         * Close the modal and reset order id.
         */
        closeModal() {
            this.showModal = false;
            return orderApi().patientIndex(this.customer.id, {page: this.page})
                .then((response) => {
                    this.orders = response.data;
                    this.totalPage = response.meta.last_page;
                });
        },
        /**
         * Open the modal and set order id.
         *
         * @param orderId
         */
        setOrderId(orderId) {
            this.orderId = orderId;
            this.showModal = true;
        },
    }
});
</script>
